/**
 * Created by madura on 1/26/17.
 */
import React, { useMemo, useState, useCallback, useEffect } from "react";
import {
    Card,
    DropdownButton,
    Dropdown,
    Typeahead,
    Button,
    Form,
    FaIcon
} from 'shoutout_themes';
import { faTimes, faCheck } from 'shoutout_themes/es/FaIconsSolid';
import { UtilService } from '../../services/Services';


const FilterInput = ({ selectedKey, selectedFilterOption, searchKey, changeSearchKey }) => {
    const changeTypeaheadInput = useCallback((data) => {
        changeSearchKey(data.length ? data[0].label : '');
    }, [changeSearchKey])
    const changeTextInput = useCallback((e) => {
        changeSearchKey(e.target.value);
    }, [changeSearchKey])
    if (selectedKey.id === 'tags') {
        const selected = searchKey ? [{ id: searchKey, label: searchKey }] : [];
        return (
            <div>
                <Typeahead
                    options={selectedKey.dataList}
                    placeholder={selectedFilterOption._inputPlaceholder}
                    onChange={changeTypeaheadInput}
                    selected={selected}
                />
            </div>
        );
    }

    return (
        <Form.Control type="text" placeholder={selectedFilterOption._inputPlaceholder}
            onChange={changeTextInput}
            value={searchKey} />
    );

}

const SubmitButton = ({ addFilter }) => {
    return (
        <Button variant="dark" size="sm" className="rounded-0 px-2 ml-2" onClick={addFilter} type="button">Add Filter</Button>
    )
}

const FiltersPreview = ({ filterList, deleteFilter }) => {

    const _deleteFilter = useCallback((e) => {
        deleteFilter(e.currentTarget.dataset.index);
    }, [deleteFilter])
    
    if (filterList.length === 0) {
        return null;
    }

 
    return (
        filterList.map(({ selectedKey, searchKey, selectedFilterOption }, index) => {
            return (
                <div className="inline-block text-white float-left" key={`f-${index}`}>
                    {index > 0 && <span className="mx-2 text-black">and</span>}
                    <span className="bg-secondary p-2 small">{selectedKey.label}<span className="ml-2">{selectedFilterOption.name}</span><span className="ml-2">{searchKey}</span><Button className="rounded-circle" size="sm" variant="default" data-index={index} onClick={_deleteFilter}><FaIcon icon={faTimes} /></Button></span>
                </div>
            )
        })
    )
}

const PeopleFilters = ({ columnNameMap, applyFilters, clearFilters, addFilter, filterList, deleteFilter }) => {
    //  const [searchKey, set]

    const [filterData, setFilterData] = useState({
        selectedKey: null,
        selectedFilterOption: null,
        searchKey: ""
    });

    const keys = useMemo(() => {
        return Object.keys(columnNameMap).reduce((result, key) => {
            if (!key.startsWith('_')) {
                result.push(key);
            }
            return result;
        }, []).sort((a, b) => a - b)
    }, [columnNameMap]);


    const filtersList = useMemo(() => {

        return Object.entries(columnNameMap).reduce((result, [key, value]) => {
            if (!key.startsWith('_')) {
                result.push({ id: key, ...value });
            }
            return result;
        }, [])

    }, [columnNameMap])

    const filterOptions = useMemo(() => {
        if (filterData.selectedKey && Object.keys(filterData.selectedKey).length > 0) {
            return UtilService.getFilters(filterData.selectedKey.type);
        }
        return [];
    }, [filterData.selectedKey])


    const selectFilterKey = useCallback((selectedFilterKey) => {
        if (selectedFilterKey && selectedFilterKey.length > 0) {
            // setSelectedKey(selectedFilterKey[0]);
            setFilterData(
                {
                    selectedFilterOption: null,
                    searchKey: "",
                    selectedKey: selectedFilterKey[0]
                }
            )
        }
        else {
            setFilterData({
                selectedFilterOption: null,
                searchKey: "",
                selectedKey: null
            })
        }
    }, [setFilterData, filterData])
    const selectFilterOptions = useCallback((eventKey) => {

        setFilterData({ ...filterData, searchKey: "", selectedFilterOption: filterOptions[parseInt(eventKey)] })
    }, [filterOptions, setFilterData, filterData])

    const changeSearchKey = useCallback((searchKey) => {
        setFilterData({ ...filterData, searchKey: searchKey })
    }, [filterData, setFilterData])

    const _addFilter = useCallback(() => {

        addFilter(filterData);

        setFilterData({
            selectedKey: null,
            selectedFilterOption: null,
            searchKey: ""

        })
    }, [addFilter, filterData, setFilterData])

    return (

        <Card className=" border-0 rounded-0 mb-3">
            <Card.Body>
                <h6 className="font-weight-bold mb-0">Filter People</h6>
                <hr className="dashed my-2" />

                <FiltersPreview filterList={filterList} deleteFilter={deleteFilter} />
                <div className="d-inline-block">


                    <div className="d-flex  align-items-center">
                        {keys.length ? <React.Fragment>
                            <Typeahead
                                id="filterKeySelector"
                                options={filtersList}
                                placeholder="Type attribute name"
                                // onChange={data => {
                                //     onChangeFilterSearchKey(data.length ? data[0].label : '', filterKey);
                                // }}
                                // selected={selected}
                                labelKey="label"
                                onChange={selectFilterKey}
                                selected={filterData.selectedKey ? [filterData.selectedKey] : []}
                                className="ml-2"
                            />
                            {filterData.selectedKey && Object.keys(filterData.selectedKey).length > 0 &&
                                <DropdownButton bsPrefix="btn btn-transparent btn-sm d-flex align-items-center" size="sm" title={filterData.selectedFilterOption ? filterData.selectedFilterOption.name : 'Select'}
                                    onSelect={selectFilterOptions}>
                                    {filterOptions.map((filter, i) => {
                                        return (<Dropdown.Item eventKey={i} key={filter.id + '-' + i}>{filter.name}</Dropdown.Item>)
                                    })
                                    }
                                </DropdownButton>
                            }

                            {filterData.selectedFilterOption && (filterData.selectedFilterOption._inputVisible ?
                                <React.Fragment><Form.Group className="mb-0 pt-0" controlId="filter-people" size="sm">
                                    <FilterInput selectedKey={filterData.selectedKey} selectedFilterOption={filterData.selectedFilterOption} searchKey={filterData.searchKey} changeSearchKey={changeSearchKey} />

                                </Form.Group>
                                    <SubmitButton addFilter={_addFilter} />
                                </React.Fragment>
                                :
                                <SubmitButton addFilter={_addFilter} />
                            )
                            }

                        </React.Fragment> :
                            <div>
                                <small className="font-weight-bold mb-0">No filters</small>
                                <br />
                                <small className="text-muted">Filters will be available once you create some people</small>
                            </div>

                        }

                    </div>




                </div>
                {filterList.length > 0 &&
                    <div className="mt-2 text-right">
                        <Button type="button" className="text-white" size="sm" variant="danger" onClick={clearFilters}><FaIcon className="mr-2" icon={faTimes} />Clear Filters</Button>
                        <Button className="text-white ml-2" size="sm" type="button" variant="success" onClick={applyFilters}><FaIcon className="mr-2" icon={faCheck} />Apply Filters</Button>
                    </div>
                }
            </Card.Body>

        </Card >

    );
};



const PeopleFilterWrapper = ({ applyFilters, selectedFilters, columnNameMap, ...rest }) => {
    const [filterList, setFilterList] = useState([]);
    const addFilter = useCallback((filter) => {
        const newFilterList=[...filterList, filter];
       
        setFilterList(newFilterList);
        applyFilters(newFilterList);
    }, [filterList, setFilterList,applyFilters])

    const _applyFilters = useCallback((e) => {
        e.preventDefault();
        applyFilters(filterList);
    }, [applyFilters, filterList])

    const deleteFilter = useCallback((filterIndex) => {
        const newFilterList = [...filterList];
        newFilterList.splice(filterIndex, 1);
        setFilterList(newFilterList);
        applyFilters(newFilterList);
    }, [filterList, setFilterList,applyFilters])

    useEffect(() => {
        if (selectedFilters.length > 0) {
            const newFilterList = selectedFilters.map(({ columnName, searchKey, _selectedFilter }) => {
                const filter = UtilService.getFilterById(_selectedFilter);
                const columnNameMapItem = columnNameMap[columnName];

                return { searchKey, selectedFilterOption: filter, selectedKey: { ...columnNameMapItem, id: columnName } }
            })
            setFilterList(newFilterList);

        } else {
            setFilterList([]);
        }
    }, [selectedFilters])
    return (
        <PeopleFilters filterList={filterList} addFilter={addFilter} {...rest} applyFilters={_applyFilters} columnNameMap={columnNameMap} deleteFilter={deleteFilter} />
    )
}
export default PeopleFilterWrapper;